import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
//import Select from "react-select";
import Layout from "../../../components/common/Layout";
import axios from "axios";
import AlertContext from "../../../context/alert/alertContext";
import Alerts from "../../layout/Alerts";
import Modal from "react-bootstrap/Modal";
import checkTime from "../../../components/constants/CheckTime"

const NameEdit = props => {
  const pagePermission =
      JSON.parse(localStorage.getItem("permission")) === null
      ? {IsCreate: false,
        IsDelete: false,
        IsUpdate: false,
        IsView: false}
      : JSON.parse(localStorage.getItem("permission")).filter(c => parseInt(c.MenuId) === 5)[0];
  const alertContext = useContext(AlertContext);

  const { setAlert } = alertContext;

  const userId = JSON.parse(localStorage.getItem("user")) === null ? null : JSON.parse(localStorage.getItem("user"))[0].Id;
  const nameId = props.match.params.id;

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    addr: "",
    fax: "",
    email: "",
    remark: "",
    taxID: "",
    initial: "",
    createBy: userId
  });
  useEffect(() => {
    checkTime();
    document.addEventListener("mousedown",  (e) => { checkTime() });
    if(!pagePermission.IsUpdate){
      window.location.href = "/home";
    }
    if (props.match.path.indexOf("edit") >= 0) {
      val_update();
    }
    //eslint-disable-next-line
  }, []);

  const [show, setShow] = useState(false);

  const val_update = () => {
    axios
      .get(process.env.REACT_APP_API_URL + "/api/names/" + nameId)
      .then(res => {
        setFormData({
          name: res.data[0].NamesName || "",
          phone: res.data[0].Telephone || "",
          addr: res.data[0].PostalAddress || "",
          fax: res.data[0].Fax || "",
          email: res.data[0].ElectronicMail || "",
          remark: res.data[0].Remark || "",
          taxID: res.data[0].TaxID || "",
          initial: res.data[0].Initial || "",
          createBy: userId
        });
      });
  };

  const { name, phone, addr, fax, email, remark, taxID, initial } = formData;

  const onChange = e =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const saveAdd = () => {
      if (props.match.path.indexOf("edit") > 0) {
        //edit
        axios
          .put(process.env.REACT_APP_API_URL + "/api/names/" + nameId, formData)
          .then(res => {
            if (res.data.status === "0") {
              setAlert(res.data.msg, "success");
              props.history.push("/names/view/" + nameId);
            } else {
              setAlert(res.data.msg, "danger");
              setShow(false);
            }
          });
      } else if ((props.match.path.indexOf("add") > 0)) {
        //add
        axios
          .post(process.env.REACT_APP_API_URL + "/api/names", formData)
          .then(res => {
            if (res.data.status === "0") {
              setAlert(res.data.msg, "success");
              props.history.push("/names/view/" + res.data.id);
            } else {
              setAlert(res.data.msg, "danger");
              setShow(false);
            }
          })
          .catch(err => {
            setAlert(err, "danger");
          });
      }
    
  };

  const button = () => {
    return(
      <div className="text-right mt-2 mb-2">
        <div>
          <button
            className="btn btn-success ml-2"
            type="button"
            onClick={()=>{
              if (name === "") {
                setAlert("name is null! Plese fill", "warning");
              }else{
                setShow(true)}}
              }
          >
            <i className="fa fa-save"></i> Save
          </button>

          {props.match.path.indexOf("edit") > 0 && (
            <button
              className="btn btn-secondary ml-2"
              type="button"
              onClick={val_update}
            >
              <i className="fa fa-refresh"></i> Reset
            </button>
          )}
          <Link to={props.match.path.indexOf("edit") > 0 ? "/names/view/" + props.match.params.id : "/names"}>
            <button className="btn btn-danger ml-2" type="button">
              <i className="fa fa-reply"></i> Cancel
            </button>
          </Link>
        </div>
      </div>
    )
  }

  return (
    <Layout activeLinkTo="/names" menuId="5">
      <div className="container-fluid" style={{ minHeight: 500 }}>
        <Alerts />
        {button()}
        <div className="card border-secondary">
          {props.match.path.indexOf("add") > 0 && (
            <h5 className="card-header text-white bg-primary">Add Name</h5>
          )}
          {props.match.path.indexOf("edit") > 0 && (
            <h5 className="card-header text-white bg-primary">Edit Name</h5>
          )}
          <div className="card-body">
            <div className="card mt-2">
              <div className="card-body row">
                <div className="form-group col labelPadRight">
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Name<span style={{ color: "red" }}> * </span>:
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control  form-control-sm"
                        name="name"
                        value={name}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Tax ID :
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="taxID"
                        value={taxID}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Postal Address :
                    </label>
                    <div className="input-group col-md-9">
                      <textarea
                        className="form-control form-control-sm"
                        rows="3"
                        name="addr"
                        type="text"
                        value={addr}
                        onChange={onChange}
                      ></textarea>
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Electronic Mail :
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="email"
                        value={email}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Telephone :
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="phone"
                        value={phone}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Fax :
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="fax"
                        value={fax}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Initial :
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="initial"
                        value={initial}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Remarks :
                    </label>
                    <div className="input-group col-md-9">
                      <textarea
                        className="form-control form-control-sm"
                        rows="3"
                        name="remark"
                        value={remark}
                        onChange={onChange}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {button()}
        </div>

      {/* Modal Save */}
      <Modal show={show} onHide={()=>{setShow(false)}} centered>
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
        <button className="btn btn-danger ml-2" onClick={()=>{setShow(false)}}><i className="fa fa-reply"></i> Cancel</button>
          <button
            className="btn btn-success ml-2"
            type="button"
            onClick={saveAdd}
          >
            <i className="fa fa-floppy-o"></i> Save
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Save */}
    </Layout>
  );
};

export default NameEdit;
